export enum PaymentStatus {
    Pending = 0,
    Fulfilled = 1,
    ChargedBack = 2,
    Failed = 3,
    PreAuthorized = 4,
    Uncaptured = 5,
    Cancelled = 6,
}
